import FlowState from '../../../../models/store/modules/otbc/flow-state.model';
import { FiltersDefaultValue } from '@dh-io-otb/otbc/src/models/entities/filters.model';
import { TestDriveMode } from '../../../../models/utilities/testdrive-mode.enum';
import {
  RequestSelectionBoxesStatus,
  RequestSelectionBoxesStep,
} from '../../../../models/entities/request-selection-boxes.model';

import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const state: FlowState = {
  modelSelected: false,
  bookingSearchFinished: false,
  didBookingSearch: false,
  model: {
    id: 0,
    modelSeries: '',
    modelType: '',
    motorisations: [],
  },
  locationSelected: false,
  initialLocation: {
    label: '',
    locationId: '',
    postalCode: '',
  },
  locationQueryFreeText: '',
  requestLocationQueryFreeText: '',
  requestLocation: {
    label: '',
    locationId: '',
    postalCode: '',
  },
  locationRadius: '',
  onlineCode: '',
  dealer: '',
  dealers: [''],
  dealerTextFilterSearch: '',
  fixedDealer: '',
  referrer: '',
  relativePath: '',
  group: '',
  subgroup: '',
  preferencesSelected: false,
  selectedDay: new Date(),
  selectedPeriod: '',
  addressSuggestion: [],
  dealerCalendar: undefined,
  bookingsSearchResults: [],
  dealersSearchResults: [],
  requestDealersSearchResults: [],
  selectedModelMotorisations: [],
  filteredBookingsSearchResults: [],
  selectedFuelType: '',
  confirmedFuelType: '',
  selectedTransmission: '',
  confirmedTransmission: '',
  selectedMotorisation: '',
  confirmedMotorisation: '',
  selectedDealerIds: [],
  selectedTimePeriod: '',
  selectedDealer: {},
  selectedVehicle: {},
  selectedVehicleType: [],
  selectedDriveType: '',
  confirmedDriveType: '',
  selectedWeight: '',
  confirmedWeight: '',
  selectedEngine: '',
  selectedWheelBase: '',
  confirmedWheelBase: '',
  availableTimePeriodOptions: [],
  availableFuelOptions: [],
  availableTransmissionOptions: [],
  availableMotorisationOptions: [],
  availableDriveTypeOptions: [],
  availableWheelBaseOptions: [],
  availableWeightOptions: [],
  availableDealersOptions: [],
  isFilterSelected: false,
  isVehicleFilterSelected: false,
  isVehicleFilterConfirmed: false,
  filtersApplied: {
    fuelType: FiltersDefaultValue.ALLFUELTYPE,
    transmission: FiltersDefaultValue.ALLTRANSMISSION,
    dealers: [],
    motorisation: '',
    timePeriod: FiltersDefaultValue.ALLDAY,
  },
  allVehicleFilters: {},
  testDriveMode: TestDriveMode.BOOKING,
  appointment: null,
  prospect: {
    customerNameSet: {},
    contactOptionsSet: {},
    customerContactsSet: {},
    customerOtherSet: {},
    customerAMGSet: {},
    declarationOfConsentSet: {},
    customerPickMeUpSet: {},
    additionalDriverSet: {},
    ciamId: null,
  },
  informationSent: null,
  showDetailsModal: false,
  showFiltersMenu: false,
  showFiltersModal: false,
  vehiclePreferences: {
    image: {
      title: '',
      url: '',
    },
    primary: [],
    secondary: [],
  },
  firstAvailableDate: new Date(),
  searchedDate: null,
  activeCalendarSlide: 0,
  requestSelectionBoxesStatus: {
    retailer: RequestSelectionBoxesStatus.AVAILABLE,
    slot: RequestSelectionBoxesStatus.TODO,
    personalData: RequestSelectionBoxesStatus.TODO,
  },
  requestSelectionBoxesStep: RequestSelectionBoxesStep.NONE,
  errorMessage: '',
  skippedResultsPage: true,
  isTestDriveFromHome: false,
  testDriveFromHomeWhitelistedDealers: [],
  didUserConsentWithOneDoc: false,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
